(function () {
  'use strict';

  var MODAL_SELECTOR = '.pplr_crop-modal';
  var IMAGE_SELECTOR = '.pplr-modal-img';
  var CONTROL_SELECTOR =
    '.p_r_c, .js_z_i, .js_z_o, .js_z_r, .js_z_l, .p_r_d';

  var NORMAL_STEP = 2;
  var FAST_STEP = 10;
  var activeModal = null;
  var lastFocusedElement = null;
  var scanScheduled = false;

  var controlLabels = {
    p_r_c: 'Confirm image crop',
    js_z_i: 'Zoom in',
    js_z_o: 'Zoom out',
    js_z_r: 'Rotate image left',
    js_z_l: 'Rotate image right',
    p_r_d: 'Delete uploaded image'
  };

  function isVisible(element) {
    var style;

    if (!element || !element.getClientRects().length) {
      return false;
    }

    style = window.getComputedStyle(element);

    return (
      style.display !== 'none' &&
      style.visibility !== 'hidden'
    );
  }

  function getVisibleModal() {
    var modals = document.querySelectorAll(MODAL_SELECTOR);
    var index;

    for (index = modals.length - 1; index >= 0; index -= 1) {
      if (isVisible(modals[index])) {
        return modals[index];
      }
    }

    return null;
  }

  function getControlLabel(control) {
    var className;

    for (className in controlLabels) {
      if (
        Object.prototype.hasOwnProperty.call(
          controlLabels,
          className
        ) &&
        control.classList.contains(className)
      ) {
        return controlLabels[className];
      }
    }

    return 'Image crop control';
  }

  function addFocusStyles() {
    var style;

    if (
      document.getElementById(
        'zepto-keyboard-crop-styles'
      )
    ) {
      return;
    }

    style = document.createElement('style');
    style.id = 'zepto-keyboard-crop-styles';

    style.textContent =
      '.pplr_crop-modal ' +
      '[data-zepto-keyboard-control="button"]:focus-visible {' +
      'outline: 2px solid #1a73e8 !important;' +
      'outline-offset: 2px !important;' +
      'border-radius: 4px !important;' +
      '}';

    document.head.appendChild(style);
  }

  function getControls(modal) {
    var nodes = modal.querySelectorAll(CONTROL_SELECTOR);
    var controls = [];
    var index;

    for (index = 0; index < nodes.length; index += 1) {
      if (isVisible(nodes[index])) {
        controls.push(nodes[index]);
      }
    }

    return controls;
  }

  function focusElement(element) {
    if (
      !element ||
      typeof element.focus !== 'function'
    ) {
      return;
    }

    try {
      element.focus({
        preventScroll: true
      });
    } catch (error) {
      element.focus();
    }
  }

  function enhanceModal(modal) {
    var controls;
    var index;

    if (!modal) {
      return;
    }

    addFocusStyles();

    if (
      modal.getAttribute(
        'data-zepto-keyboard-ready'
      ) !== 'true'
    ) {
      modal.setAttribute(
        'data-zepto-keyboard-ready',
        'true'
      );

      modal.setAttribute('role', 'dialog');
      modal.setAttribute('aria-modal', 'true');
      modal.setAttribute(
        'aria-label',
        'Image crop editor'
      );

      controls = modal.querySelectorAll(
        CONTROL_SELECTOR
      );

      for (
        index = 0;
        index < controls.length;
        index += 1
      ) {
        controls[index].setAttribute(
          'tabindex',
          '0'
        );

        controls[index].setAttribute(
          'role',
          'button'
        );

        controls[index].setAttribute(
          'data-zepto-keyboard-control',
          'button'
        );

        if (
          !controls[index].getAttribute(
            'aria-label'
          )
        ) {
          controls[index].setAttribute(
            'aria-label',
            getControlLabel(controls[index])
          );
        }
      }
    }

    if (activeModal !== modal) {
      lastFocusedElement = document.activeElement;
      activeModal = modal;
      controls = getControls(modal);

      window.setTimeout(function () {
        if (
          activeModal === modal &&
          isVisible(modal) &&
          controls.length
        ) {
          focusElement(controls[0]);
        }
      }, 0);
    }
  }

  function moveImage(
    modal,
    horizontal,
    vertical
  ) {
    var image = modal.querySelector(
      IMAGE_SELECTOR
    );

    var jq = window.jQuery || window.$;
    var instance;

    if (!image) {
      return false;
    }

    try {
      if (
        image.cropper &&
        typeof image.cropper.move === 'function'
      ) {
        image.cropper.move(
          horizontal,
          vertical
        );

        return true;
      }

      if (
        jq &&
        jq.fn &&
        typeof jq.fn.cropper === 'function'
      ) {
        instance = jq(image).data('cropper');

        if (
          instance &&
          typeof instance.move === 'function'
        ) {
          instance.move(
            horizontal,
            vertical
          );

          return true;
        }

        jq(image).cropper(
          'move',
          horizontal,
          vertical
        );

        return true;
      }
    } catch (error) {
      return false;
    }

    return false;
  }

  function clickControl(modal, selector) {
    var control = modal.querySelector(selector);

    if (
      !control ||
      !isVisible(control)
    ) {
      return false;
    }

    control.click();
    return true;
  }

  function activateFocusedControl(modal) {
    var focused = document.activeElement;

    if (
      !focused ||
      !modal.contains(focused) ||
      focused.getAttribute(
        'data-zepto-keyboard-control'
      ) !== 'button'
    ) {
      return false;
    }

    focused.click();
    return true;
  }

  function handleTab(event, modal) {
    var controls = getControls(modal);
    var currentIndex;
    var nextIndex;

    if (!controls.length) {
      return;
    }

    currentIndex = controls.indexOf(
      document.activeElement
    );

    if (event.shiftKey) {
      nextIndex =
        currentIndex <= 0
          ? controls.length - 1
          : currentIndex - 1;
    } else {
      nextIndex =
        currentIndex < 0 ||
        currentIndex >= controls.length - 1
          ? 0
          : currentIndex + 1;
    }

    event.preventDefault();
    focusElement(controls[nextIndex]);
  }

  function isTextEntry(element) {
    if (
      !element ||
      !element.tagName
    ) {
      return false;
    }

    return (
      element.tagName === 'INPUT' ||
      element.tagName === 'TEXTAREA' ||
      element.tagName === 'SELECT' ||
      element.isContentEditable
    );
  }

  function onKeyDown(event) {
    var modal = getVisibleModal();
    var step;
    var handled = false;

    if (!modal) {
      return;
    }

    enhanceModal(modal);

    if (event.key === 'Tab') {
      handleTab(event, modal);
      return;
    }

    if (
      event.ctrlKey ||
      event.metaKey ||
      event.altKey ||
      isTextEntry(event.target)
    ) {
      return;
    }

    if (
      event.key === 'Enter' ||
      event.key === ' '
    ) {
      if (activateFocusedControl(modal)) {
        event.preventDefault();
        scheduleScan();
        return;
      }
    }

    if (
      !modal.contains(
        document.activeElement
      )
    ) {
      return;
    }

    step = event.shiftKey
      ? FAST_STEP
      : NORMAL_STEP;

    if (event.key === 'ArrowLeft') {
      handled = moveImage(
        modal,
        -step,
        0
      );
    } else if (
      event.key === 'ArrowRight'
    ) {
      handled = moveImage(
        modal,
        step,
        0
      );
    } else if (
      event.key === 'ArrowUp'
    ) {
      handled = moveImage(
        modal,
        0,
        -step
      );
    } else if (
      event.key === 'ArrowDown'
    ) {
      handled = moveImage(
        modal,
        0,
        step
      );
    } else if (
      event.key === '+' ||
      event.key === '='
    ) {
      handled = clickControl(
        modal,
        '.js_z_i'
      );
    } else if (
      event.key === '-' ||
      event.key === '_'
    ) {
      handled = clickControl(
        modal,
        '.js_z_o'
      );
    } else if (
      event.key === '['
    ) {
      handled = clickControl(
        modal,
        '.js_z_r'
      );
    } else if (
      event.key === ']'
    ) {
      handled = clickControl(
        modal,
        '.js_z_l'
      );
    }

    if (handled) {
      event.preventDefault();
      scheduleScan();
    }
  }

  function scanForModal() {
    var modal = getVisibleModal();

    scanScheduled = false;

    if (modal) {
      enhanceModal(modal);
      return;
    }

    if (
      activeModal &&
      lastFocusedElement &&
      document.contains(
        lastFocusedElement
      )
    ) {
      focusElement(lastFocusedElement);
    }

    activeModal = null;
    lastFocusedElement = null;
  }

  function scheduleScan() {
    if (scanScheduled) {
      return;
    }

    scanScheduled = true;

    window.setTimeout(
      scanForModal,
      0
    );
  }

  document.addEventListener(
    'keydown',
    onKeyDown,
    true
  );

  document.addEventListener(
    'click',
    scheduleScan,
    true
  );

  document.addEventListener(
    'change',
    scheduleScan,
    true
  );

  if (window.MutationObserver) {
    new MutationObserver(
      scheduleScan
    ).observe(
      document.documentElement,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      scheduleScan
    );
  } else {
    scheduleScan();
  }
})();